/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  previewmodecode: {
    width: '100% !important',
    '&.disabled-true': {
      opacity: 0.5,
      pointerEvents: 'none'
    },
    '& .name-copycta': {
      marginRight: `0 !important`
    },
    '& .name-copyfield': {
      width: pxToEm(240)
    },
    '& .codepiece .description': {
      marginTop: `0 !important`
    },
    '& .codepiece .ctas': {
      marginRight: `0 !important`
    }
  }
});
